import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import ButtonBase from '@mui/material/ButtonBase';

// project imports
import Logo from './LogoMain';
import LogoIcon from './LogoIcon';
import useAuth from 'hooks/useAuth';

export default function LogoSection({ reverse, isIcon, sx, to }) {
  const { user } = useAuth();

  // Determine dashboard path based on user role
  const getDashboardPath = () => {
    if (to) return to;
    if (user?.role === 'supervisor') return '/supervisor/dashboard';
    if (user?.role === 'therapist') return '/therapist/dashboard';
    if (user?.role === 'inclusionhead') return '/inclusionhead/child-profiles';
    return '/supervisor/dashboard'; // default fallback
  };

  return (
    <ButtonBase disableRipple component={Link} to={getDashboardPath()} sx={sx}>
      {isIcon ? <LogoIcon /> : <Logo reverse={reverse} />}
    </ButtonBase>
  );
}

LogoSection.propTypes = { reverse: PropTypes.bool, isIcon: PropTypes.bool, sx: PropTypes.any, to: PropTypes.any };
